import Swiper from 'swiper';
import 'swiper/css';

export class SwiperButtons {
	constructor($container, options = {}) {
		this.$container = $container;
		this.options = options;

		this.init($container);
	}

	init($container) {
		const swiper = $container.querySelector('.js-swiper-buttons__swiper');
		if (!swiper) return;

		this.swiper = new Swiper(swiper, {
			slidesPerView: 'auto',
			spaceBetween: this.options.spaceBetween || 8,
		});
	}
}
